/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// libraries
import React from 'react';
import { object, string } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import {  getSSRDeviceType } from '../../../../../state/ducks/App/App-Selectors';

const styles = (theme) => ({
    root: {
        marginBottom: '20px',
        padding: '24px 10px',
        fontSize: '16px',
        fontFamily: 'Roboto',
        textAlign: 'center',
        borderTop: '1px solid #d8d8d8',
        borderBottom: '1px solid #d8d8d8',
    },
    [theme.breakpoints.down('sm')]: {
        root: {
            padding: '10px 0',
            fontSize: '13px',
        },
    },
});

const SCIProductBannerUI = ({ classes, ssrDeviceType }) => (
    ssrDeviceType === 'Desktop' && (
        <div className={classes.root}>
            If funeral arrangements have been postponed, we offer condolence gifts including gourmet food baskets, gourmet meals, flowers and plants to send to your loved ones to let them know you are thinking of them.
        </div>
    )
);

SCIProductBannerUI.propTypes = {
    classes: object.isRequired,
    ssrDeviceType: string.isRequired,
};
const mapStateToProps = (state) => ({
    ssrDeviceType: getSSRDeviceType(state),
});
const enhance = compose(
    withStyles(styles),
    connect(mapStateToProps),
);
export default enhance(SCIProductBannerUI);
